Object.defineProperty(exports,"__esModule",{value:true});exports.default=






fixtureHealthStatus;var _securityDeviceHealthStatus=require('./securityDeviceHealthStatus');var _positionHealthStatus=require('./positionHealthStatus');var _positionHealthStatus2=_interopRequireDefault(_positionHealthStatus);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function fixtureHealthStatus(fixture){
var positions=fixture.positionIds.toModelArray();
if(!positions||positions.length===0){
return{
type:_securityDeviceHealthStatus.HealthStatus.MISSING_SECURITY_DEVICE};

}

return(0,_securityDeviceHealthStatus.worsedHealthStatus)(positions.map(_positionHealthStatus2.default));
}